<template>
  <form>
    <tr-slimbox
      :fixed-height="fixedHeight"
      :with-border="true"
      :classes="classes"
      :with-dashed-border="true"
    >
      <slot
        v-if="currentState === dragAndDropStateConstant.DRAG_STATE"
        name="dragState"
      />
      <slot
        v-if="currentState === dragAndDropStateConstant.DRAG_OVER_STATE"
        name="dragOverState"
      />
      <slot
        v-if="currentState === dragAndDropStateConstant.LOADING_STATE"
        name="loadingState"
      />
      <slot
        v-if="currentState === dragAndDropStateConstant.ERROR_STATE"
        name="errorState"
      />
    </tr-slimbox>
  </form>
</template>

<script>
import TrSlimbox from './TrSlimbox.vue';
import dragAndDropStateConstant from '../constants/dragAndDropState';
import jQuery from 'jquery';

export default {
  name: 'TrDragAndDropArea',
  components: {
    TrSlimbox
  },
  props: {
    onDrop: {
      required: true,
      type: Function
    },
    fixedHeight: {
      required: false,
      type: Number
    },
    classes: {
      required: false,
      type: String
    }
  },
  data: () => ({
    dragAndDropStateConstant,
    currentState: dragAndDropStateConstant.DRAG_STATE
  }),
  mounted() {
    this.setListeners()
  },
  methods: {
    setListeners() {
      const $form = jQuery('form');
      $form.off('drag dragstart dragend dragover dragenter dragleave drop');
      $form.on('drag dragstart dragend dragover dragenter dragleave drop', e => {
        e.preventDefault();
        e.stopPropagation();
      }).on('dragover dragenter', () => {
        this.currentState = dragAndDropStateConstant.DRAG_OVER_STATE;
      }).on('dragleave', () => {
        this.currentState = dragAndDropStateConstant.DRAG_STATE;
      }).on('drop', e => {
        const droppedFiles = e.originalEvent.dataTransfer.files;
        this.onDrop(droppedFiles);
      });
    },
    setErrorState() {
      this.currentState = dragAndDropStateConstant.ERROR_STATE;
    },
    setLoadingState() {
      this.currentState = dragAndDropStateConstant.LOADING_STATE;
    },
    setDragState() {
      this.currentState = dragAndDropStateConstant.DRAG_STATE;
    }
  },
};
</script>
